module.exports = __webpack_public_path__ + "static/media/countdown_instructions.7ffa97ab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/countdown_instructions.png
// module id = 837
// module chunks = 0